export default "__VITE_ASSET__eff2cc1b__"